import * as React from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { assertUnreachable } from 'utils';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { IconBoldArrow } from '../icons';
const getText = (sortMethod) => {
    switch (sortMethod) {
        case 'Alphabetical':
            return 'A to Z';
        case 'Frequency':
            return 'Frequency';
        case 'Recent':
            return 'Recent';
        default: {
            assertUnreachable(sortMethod);
            return '';
        }
    }
};
const SortBySelector = ({ onPress, sortMethod, }) => (<TouchableBounce style={styles.container} onPress={onPress}>
    <IconBoldArrow alt width={16} height={16} colorKey="brand" direction="bottom"/>
    <Spacer w={6}/>
    <Text Text-16 Primary>
      {getText(sortMethod)}
    </Text>
  </TouchableBounce>);
export default SortBySelector;
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
});
